<div class="dashboardHeader">
    <h4 class="dashboardHeading text-shadow">Student Assessment Details</h4>
</div>
<div id="studentCharts" class="col-12 cardContainer" style="width: 100%;">
    <div class="col-12 p-0">
        <div class="col-12 col-md-3 col-sm-3 p-0 tile floatLeft">
            <div class="card CardItem">
                <div class="col-12">
                    <span>Total Students</span>
                    <h2>{{counts?.totalStudents.count}}</h2>
                </div>
                <div>
                    <apx-chart
                        [series]="TotalStudents.series"
                        [chart]="TotalStudents.chart"
                        [plotOptions]="TotalStudents.plotOptions"
                        [tooltip]="TotalStudents.tooltip"
                        [colors]="TotalStudents.colors"
                    ></apx-chart>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-3 col-sm-3 p-0 tile floatLeft">
            <div class="card CardItem">
                <div class="col-12">
                    <span>Registered for PARAKH</span>
                    <h2>{{counts?.registeredStudents.count}}</h2>
                </div>
                <div>
                    <apx-chart
                        [series]="RegisteredStudents.series"
                        [chart]="RegisteredStudents.chart"
                        [plotOptions]="RegisteredStudents.plotOptions"
                        [tooltip]="RegisteredStudents.tooltip"
                        [colors]="RegisteredStudents.colors"
                    ></apx-chart>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-3 col-sm-3 p-0 tile floatLeft">
            <div class="card CardItem">
                <div class="col-12">
                    <span>Given Assessments</span>
                    <h2>{{counts?.assessmentCounts.count}}</h2>
                </div>
                <div>
                    <apx-chart
                        [series]="GivenAssessments.series"
                        [chart]="GivenAssessments.chart"
                        [plotOptions]="GivenAssessments.plotOptions"
                        [tooltip]="GivenAssessments.tooltip"
                        [colors]="GivenAssessments.colors"
                    ></apx-chart>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-3 col-sm-3 p-0 tile floatLeft">
            <div class="card CardItem">
                <div class="col-12">
                    <span>Average Score</span>
                    <h2>{{counts?.averageScore.count}}</h2>
                </div>
                <div>
                    <apx-chart
                        [series]="AverageScore.series"
                        [chart]="AverageScore.chart"
                        [plotOptions]="AverageScore.plotOptions"
                        [tooltip]="AverageScore.tooltip"
                        [colors]="AverageScore.colors"

                    ></apx-chart>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 col-md-12 col-sm-12 p-0">
       
        <div class="card CardItem  mat-elevation-z8">
            <div class="row">
                <div class="col-10 col-md-10 col-sm-10 col-xs-10" style="padding-top:15px;">
                    <mat-form-field appearance="outline" class="col-12">
                        <mat-label>Search</mat-label>
                        <input matInput (keyup)="applyFilter($event)" placeholder="Search..." #input>
                        <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>
                </div>
                <div class="col-2 col-md-2 col-sm-2 col-xs-2" style="margin-top:30px;">
                    <button mat-raised-button color="primary" class="float-left" (click)='exportAsExcelFile()'>Export Data</button>
                </div>
            </div>
            <div class="tableContainer">
                <mat-table #table [dataSource]="dataSource" multiTemplateDataRows matSort #sort="matSort" class="matTable">
                    <!--- Note that these columns can be defined in any order.
                    The actual rendered columns are set as a property on the row definition" -->

                    <!-- Student ID Column -->
                    <ng-container matColumnDef="student_id">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Student ID </mat-header-cell>
                        <mat-cell *matCellDef="let element" style="cursor: pointer;" (click)="expandedElement = expandedElement === element ? null : element"> {{element.student_id}} </mat-cell>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef mat-sort-header style="margin-left: 30px;"> Name </mat-header-cell>
                        <mat-cell *matCellDef="let element" style="cursor: pointer;" (click)="expandedElement = expandedElement === element ? null : element"> {{element.name}} </mat-cell>
                    </ng-container>

                    <!-- Dicipline Column -->
                    <ng-container matColumnDef="discipline">
                        <mat-header-cell *matHeaderCellDef mat-sort-header style="margin-left: 45px;"> Discipline </mat-header-cell>
                        <mat-cell *matCellDef="let element" style="cursor: pointer;" (click)="expandedElement = expandedElement === element ? null : element"> {{element.course}} </mat-cell>
                    </ng-container>

                    <!-- Batch Column -->
                    <ng-container matColumnDef="batch">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Batch </mat-header-cell>
                        <mat-cell *matCellDef="let element" style="cursor: pointer;" (click)="expandedElement = expandedElement === element ? null : element"> {{element.date_of_addmission}} </mat-cell>
                    </ng-container>

                    <!-- Assessment Type Column -->
                    <ng-container matColumnDef="assessment_type">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Assessment Type </mat-header-cell>
                        <mat-cell *matCellDef="let element" style="cursor: pointer;" (click)="expandedElement = expandedElement === element ? null : element"> {{element.type}} </mat-cell>
                    </ng-container>

                    <!-- Assessment Date Column -->
                    <ng-container matColumnDef="assessment_date">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Assessment Date </mat-header-cell>
                        <mat-cell *matCellDef="let element" style="padding-left: 30px;cursor: pointer;" (click)="expandedElement = expandedElement === element ? null : element"> {{element.created_at | date: 'dd-MM-yyyy'}} </mat-cell>
                    </ng-container>

                    <!-- Assessment Date Column -->
                    <ng-container matColumnDef="view_report">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> View Report </mat-header-cell>
                        <mat-cell *matCellDef="let element" style="cursor: pointer;">
                            <button  mat-icon-button
                                class="example-element-row"
                                [class.example-expanded-row]="expandedElement === element"
                                (click)="navigateToReport(element?.id)">
                                Click Here
                            </button>
                        </mat-cell>
                    </ng-container>

                    <!-- Expanded Content Column - The detail row is made up of this one column -->
                    <ng-container matColumnDef="expandedDetail">
                        <mat-cell *matCellDef="let element" class="p-0">
                            <div class="studentDetails" style="margin-top: 15px;">
                                <p><strong>Marks Obtained : </strong>{{element.marks_obtained}}</p>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="rating">
                        <!-- <mat-header-cell *matHeaderCellDef style="width: 10%;"> Overall Rating </mat-header-cell> -->
                        <mat-cell *matCellDef="let row" class="p-0">
                                <div class="half-stars-example row">
                                    <div class="col">Overall Rating</div>
                                  <div class="half-stars-example" *ngIf="row?.ratings==1">
                                    <div *ngFor="let rate of rating1">
                                      <svg class="review__star {{rate}}" width="20" height="20" viewBox="0 0 51 48">
                                        <path d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div class="half-stars-example" *ngIf="row?.ratings==2">
                                    <div *ngFor="let rate of rating2">
                                      <svg class="review__star {{rate}}" width="20" height="20"  viewBox="0 0 51 48">
                                        <path d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div class="half-stars-example" *ngIf="row?.ratings==3">
                                    <div *ngFor="let rate of rating3">
                                      <svg class="review__star {{rate}}" width="20" height="20"  viewBox="0 0 51 48">
                                        <path d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div class="half-stars-example" *ngIf="row?.ratings==4">
                                    <div *ngFor="let rate of rating4">
                                      <svg class="review__star {{rate}}" width="20" height="20"  viewBox="0 0 51 48">
                                        <path d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div class="half-stars-example" *ngIf="row?.ratings==5">
                                    <div *ngFor="let rate of rating5">
                                      <svg class="review__star {{rate}}" width="20" height="20"  viewBox="0 0 51 48">
                                        <path d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <button  mat-icon-button *ngIf="expandedElement == element"
                                [class.expanded]="expandedElement == undefined"
                                (click)="expandedElement = undefined">
                                <mat-icon>remove_circle_outline</mat-icon>
                            </button>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row"></mat-row>
                    <mat-row *matRowDef="let row; columns: ['expandedDetail','rating'];"
                        [@detailExpand]="row == expandedElement ? 'expanded' : 'collapsed'" style="overflow: hidden">
                    </mat-row>
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" style="padding-top:20px; padding-bottom:20px;" colspan="4">No data matching the filter "{{input.value}}"</td>
                    </tr>

                </mat-table>
                <mat-paginator
                #paginator="matPaginator"
                [pageSize]="5"
                [pageSizeOptions]="[5, 10, 25, 100]"
                showFirstLastButtons
                >
                </mat-paginator>
            </div>
        </div>
    </div>
</div>
